"use client"
import React, { Fragment, useState, useEffect } from "react";

import ScrollBox from "@/components/shared/ScrollBox";

import "@/components/shared/TagsFilter.css";

const TagsFilter = ({ className, points, onSelect, scrollable }) => {
  const [loaded, setLoaded] = useState(false);
  const [selected, setSelected] = useState([]);
  const [options, setOptions] = useState([]);

  useEffect(() => {
    if (points) {
      var allOptions = [
        ...new Set(
          []
            .concat(
              [],
              points.map(pt => pt.tags)
            )
            .flat()
        )
      ];
      // console.log("allOptions", allOptions);
      allOptions = allOptions.filter(o => o != null);
      setOptions(allOptions.map(o => buildOption(o)));
      setLoaded(true);
    }
  }, [points]);

  const buildOption = label => {
    return {
      label: label,
      value: label
    };
  };

  const handleChange = selectedOptions => {
    // commenting this out for now, not sure what this is about
    // setSelected(basic ? selectedOptions : null);
    // console.log("TagsFilter handleChange", selectedOptions);
    setSelected(selectedOptions);
    if (onSelect) {
      if (selectedOptions && selectedOptions.length > 0) {
        onSelect(filterPoints(selectedOptions));
      } else {
        onSelect(null);
      }
    }
  };

  const filterPoints = selectedTags => {
    return points.filter(pt => intersects(pt.tags, selectedTags));
  };

  const intersects = (data, reference) => {
    var arrayFilter = data.filter(it => reference.includes(it));
    // console.log("intersection",data.length,reference.length,arrayFilter.length);
    return arrayFilter.length > 0;
  };

  const toggle = val => {
    // console.log("TagsFilter toggle", val, selected);
    var newSelected = [...selected];
    var idx = newSelected.findIndex(v => v === val);
    if (idx > -1) {
      newSelected.splice(idx, 1);
    } else {
      newSelected.push(val);
    }
    handleChange(newSelected);
  };

  const elements = (opts, selectedOpts) => {
    // console.log("TagsFilter elements", opts, selectedOpts);
    var theElements = opts.map((opt, index) => {
      return (
        <Fragment key={index}>
          <span
            className={`entry ${
              selectedOpts.includes(opt.value) ? "selected" : ""
            }`}
            onClick={() => toggle(opt.value)}
          >
            <span className="text">{opt.label}</span>
          </span>
        </Fragment>
      );
    });
    return theElements;
  };

  if (loaded && options.length > 0) {
    return (
      <div className={`tags-filter ${className}`}>
        {options && (
          <>
            {scrollable ? (
              <ScrollBox>{elements(options, selected)}</ScrollBox>
            ) : (
              <>{elements(options, selected)}</>
            )}
          </>
        )}
      </div>
    );
  } else {
    return <></>;
  }
};
export default TagsFilter;
